import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypographyComponent } from '@hyperkit'
import { ExpandedHuntPackageRecord } from '@cyborg-monorepo/hunter/common';
@Component({
  selector: 'hunt-package-list-item',
  imports: [CommonModule, TypographyComponent],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss',
})
export class HuntPackageListItem {
  @Input() huntPackage: ExpandedHuntPackageRecord; 
}
